<template>
  <div class="content">
    <ul v-for="(item, index) in dataJson" :key="index">
      <li v-if="item.data" >
        <h3 class="title">{{item.name}}</h3>
        <div v-if="item.dataType==='text'">
          <div v-if="item.data.url">
            {{item.data.preData}}
            <el-link :underline="underLine" type="primary" :href="item.datas.url">{{item.datas.link}}</el-link>
            {{item.data.endData}}
          </div>
          <div v-else>{{item.data}}</div>
        </div>
        <div v-if="item.dataType==='array'">
          <div v-for="(subItem, index2) in item.data" style="padding-left: 2rem;" :key="'array-' + index + '-' + index2">
          <p v-if="subItem.url">
            {{subItem.preData}}
            <el-link :underline="underLine" type="primary" :href="subItem.url">{{ subItem.link }}</el-link>
            {{subItem.endData}}
          </p>
          <div v-else>{{subItem}}</div>
          </div>
        </div>
        <div v-if="item.dataType==='flow'">
          <div v-for="(subItem, index2) in item.data" class="img-flow" :key="'img-' + index + '-' + index2">
            <h4>{{subItem.name}}</h4>
            <div v-for="(desc, index3) in subItem.desc" :key="index3" style="padding-left: 2rem;">
              <div v-if="desc.preData">
                {{desc.preData}}
                <el-link :underline="underLine" type="primary" :href="desc.url">{{ desc.link }}</el-link>
                {{desc.endData}}
                <strong v-if="desc.warning" class="desc-warning">
                  <i class="el-icon-warning"></i>&nbsp;注意:&nbsp;{{desc.warning}}
                </strong>
              </div>
              <div v-else-if="desc && typeof desc !== 'string' && desc.length > 1">
                <span v-for="(subDesc, index5) in desc" :key="'subDesc-' +index5">
                  <!-- <span v-if="subDesc.url"> -->
                    {{subDesc.preData}}
                    <el-link :underline="underLine" type="primary" :href="subDesc.url">{{ subDesc.link }}</el-link>
                    {{subDesc.endData}}

                  <!-- </span> -->
                </span>
              </div>
              <div v-else><strong>{{desc}}</strong></div>
            </div>
            <div class="img-block" v-if="subItem.url">
              <h4 class="demonstration">流程图：</h4>
              <el-image
                @click="openViewer(item.data, index2)"
                :src="subItem.url">
              </el-image>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="viewerUrl"
    ></el-image-viewer>
  </div>
</template>


<script>
  import ElImageViewer from "element-ui/packages/image/src/image-viewer";

  export default {
    name: "",
    components: {
      'el-image-viewer': ElImageViewer
    },
    props: {
      Pdatas: {
        type: Object
      }
    },
    data() {
      return {
        dataJson: [
          { name: "接口对接流程", data: this.Pdatas.flow, dataType: "flow" },
          // { name: "说明", data: this.Pdatas.flowDesc, dataType: "array" },
        ],
        othersData: [],
        explainWidth: 200,
        underLine: false,
        showViewer: false,
        viewerUrl: []
      };
    },
    methods: {

      openViewer(list, index2) {
        list.find((item, index) => {
          if(index === index2) {
            return this.viewerUrl[0] = item.url
          }
        })

        let t = this
        this.showViewer = true
        this.$nextTick(() => {
          document.querySelector(".el-image-viewer__mask").onclick = function () {
            t.showViewer = false;
          };
        });
      },

      closeViewer() {
        this.showViewer = false
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .content {
    font-size: 14px;
    h3 {
      font-size: 16px;
       margin: 20px 0 10px 0;
    }
    ul {
      padding: 5px 10px;
      padding: 5px 5px 20px 0;

      li {
        text-align: left;
        div {
          margin-top: 5px;
        }
        .desc-warning {
          color: #f56c6c
        }
        a:hover {
          text-decoration: none;
        }
        .el-image {
          cursor: pointer;
          /*width: 100px;*/
          /*height: 100px;*/
        }
        .img-flow {
          // padding-left: 2rem;
          padding: 0 0 1rem 2rem;
        }
        .img-block {
          /*width: 100px;*/
          // text-align: center;
          // margin: 20px 0;
        }

      }
    }
    .linkA {
      color: #20a0ff;
      // text-decoration: underline #20a0ff;
      &:hover {
        color: #117ecc;
        //   text-decoration: none;
      }
    }
  }

  .subName {
    padding: 15px 0 0px 0px;
    max-width: 90%;
    min-width: 80%;
    color: #333;
  }

  table {
    display: table;
    max-width: 90%;
    min-width: 80%;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: auto;
    border-bottom: 1px solid #e7e7eb;
  }

  thead tr:first-child {
    background-color: #f6f8f9;
  }

  table tr:first-child {
    border: none;
  }

  table tr {
    border-top: 1px solid #e7e7eb;
  }

  table th {
    font-weight: 400;
    color: #8d8d8d;
    text-align: left;
    height: 40px;
    padding: 6px 12px;
    white-space: nowrap;
    border: none;
  }

  table td {
    // height: 35px;
    padding: 15px 12px;
    text-align: justify;
  }

  pre {
    background-color: #f6f6f6;
  }
</style>



// WEBPACK FOOTER //
// src/components/flowStructure.vue